import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useMe } from "@/hooks/useMe";

interface RequireProvisionerProps {
	children: ReactNode;
}

// Route-level guard for provisioning affordances (owner/admin only). Purely
// a UX nicety — the server enforces the same gate regardless — but it stops
// a "member" from landing on the provisioning form via a direct URL.
export const RequireProvisioner = (props: RequireProvisionerProps) => {
	const { children } = props;
	const { data: me, isLoading } = useMe();

	if (isLoading) {
		return null;
	}

	if (me?.member.role === "member") {
		return <Navigate to="/clients" replace />;
	}

	return <>{children}</>;
};
